import styled from 'styled-components';
import { Container, Title } from '../../styles';

export const ContainerDesktop = styled(Container)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 10px;
  margin: 20px 0;
`;
export const TitleDesktop = styled(Title)`
  font-size: 24px;
  display: flex;
  align-items: center;

  .icon {
    margin-left: 10px;
    animation: go-back 1s ease-in-out infinite alternate;
  }
  * {
    color: #00b1f1;
  }

  @keyframes go-back {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(3px);
    }
  }
`;

export const ContainerDate = styled.div`
  display: flex;
  align-items: baseline;

  .ContainerOptions {
    list-style: none;
    display: flex;
    align-items: center;

    li {
      font-family: 'Roboto';
      font-weight: 500;
      font-size: 20px;
      margin: 0 15px;
      padding: 2px;
      cursor: pointer;
      color: rgba(0, 0, 0, 0.85);

      :hover {
        color: #1890ff;
      }
    }
    .active {
      color: #1890ff;
    }
  }
`;

export const SeletorData = styled.div`
  height: 100%;
`;
